import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page Not Found | SyndaFam"
        description="This page doesn't exist. Head back to SyndaFam — independent Toronto music, videos, artwork and creative culture from the collective."
        noindex
      />
      <section className="min-h-[70vh] flex flex-col items-center justify-center px-5 py-24 text-center" data-testid="notfound-page">
        <div className="font-mono text-[10px] tracking-[0.4em] text-[#E63946] mb-3">// 404 — LOST IN THE ALLEY</div>
        <h1 className="font-display text-6xl sm:text-7xl mb-4">DEAD LINK.</h1>
        <p className="text-white/60 max-w-md mb-8">
          The page you tried to reach doesn&apos;t exist here. Slide back to the home page and pick up where the wave is moving.
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          <Link to="/" className="font-mono text-xs tracking-widest px-5 py-3 bg-[#E63946] text-white inline-flex items-center gap-2 hover:bg-[#C92A36]" data-testid="notfound-home-btn">
            <Home className="w-4 h-4" /> HOME
          </Link>
          <Link to="/artists" className="font-mono text-xs tracking-widest px-5 py-3 border border-white/20 hover:border-[#FCA311] hover:text-[#FCA311] inline-flex items-center gap-2" data-testid="notfound-artists-btn">
            <ArrowLeft className="w-4 h-4" /> ARTIST ROSTER
          </Link>
        </div>
      </section>
    </>
  );
}
